<template>
  <div
    class="flash text-center font-bold flash--warning"
    role="alert"
  >
    {{ membershipFee.title }} must be paid by {{ gracePeriodEndsAt.format('MM/DD') }} to maintain access to this organization.
    <a
      href="#"
      @click="showSubmitPaymentModal = true"
      v-text="'Pay Now'"
    />
    <MembershipPaymentModal
      :show="showSubmitPaymentModal"
      @close="closeSubmitPaymentModal"
      @paymentSubmitted="handleSubmittedPayment"
    />
  </div>
</template>

<script type="text/babel">
import MembershipPaymentModal from 'Payments/Resources/assets/js/components/_modals/MembershipPaymentModal'
import moment from 'moment'

export default {
  name: 'GracePeriodRibbon',
  components: {
    MembershipPaymentModal,
  },
  props: {
    gracePeriod: {
      type: String,
      required: true,
    },
    membershipFee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showSubmitPaymentModal: false,
    }
  },
  computed: {
    gracePeriodEndsAt() {
      return moment(this.gracePeriod)
    },
  },
  methods: {
    closeSubmitPaymentModal() {
      this.showSubmitPaymentModal = false
    },
    handleSubmittedPayment() {
      this.closeSubmitPaymentModal()

      window.location.reload()
    },
  },
}
</script>
